module EnvironmentVariables {
    module.controller("NewItemController", [
        "$scope",
        "$rootScope",
        "DataTypeService",
        function ($scope, $rootScope, dataTypeService) {
            var self = this;

            self.dataTypes = dataTypeService.dataTypes;
            self.formOpen = false;

            self.defaultDataType = _.find(self.dataTypes, function (dataType:any) { return dataType.typeName === "String"; });
            var cleanItem = { dataType: self.defaultDataType, key: "", value: self.defaultDataType.getDefaultValue() };
            self.newItem = angular.copy(cleanItem);

            self.resetForm = function (form) {
                self.newItem = angular.copy(cleanItem);
                form.$setPristine();
                form.$dirty = false;
            };

            self.addItem = function (parent, form) {
                // Calls the "addItem()" function on the parent controller. The function is bound to this controller.
                $scope.addItemFn({ newItem: self.newItem, parent: parent, parentKey: $scope.parentKey });
                self.resetForm(form);
                self.closeForm();
            };

            self.selectDataType = function (dataType) {
                self.newItem.dataType = dataType;
                self.newItem.value = dataType.getDefaultValue();
            };

            self.hideSecret = function (dataType){
                // Don't allow secrets inside arrays because we cannot merge old values reliably
                var isSecret = dataType.typeName === "Secret"; 
                return isSecret && ($scope.parent === null || dataTypeService.getType($scope.parent) === "Array");
            }

            self.hideBlockTypes = function (dataType) { // Used for data tyep ng-repeat for type selector
                var blockType = dataType.typeName === "Array" || dataType.typeName === "Object";
                return blockType && !$scope.topLevel;
            };
            self.hideValueInput = function () { // Used to hide the value field when adding an array or object on top level.
                return self.newItem.dataType.typeName === "Array" || self.newItem.dataType.typeName === "Object";
            };
            self.hideKeyInput = function () { // Used to hide the key field when adding arrays.
                // an array item may have a null parent (array has not been initialized for an environment before)
                return $scope.parent === null || dataTypeService.getType($scope.parent) === "Array";
            };
            self.openForm = function () {
                self.formOpen = true;
                $rootScope.$emit('newItemFormOpened', {});
            }
            self.closeForm = function () {
                self.formOpen = false;
                $rootScope.$emit('newItemFormClosed', {});
            }
        }
    ]);
}